// extracted by mini-css-extract-plugin
export default {"promo":"promo--HFnSY","promoTitle":"promoTitle--akz3g","promoDescription":"promoDescription--hwNw1"};